import * as yup from "yup";

const salidaEmpleadoValidacionEsquema = () =>
    yup.object().shape({
        empleadoId: yup
            .number()
            .typeError("El empleado es requerido")
            .required("El empleado es requerido")
            .min(1, "El empleado es requerido"),

        fechaHoraSalida: yup
            .date()
            .typeError("La fecha y hora de salida es requerida")
            .required("La fecha y hora de salida es requerida"),

        destino: yup
            .string()
            .required("El destino es requerido")
            .max(300, "El destino no puede exceder 300 caracteres"),

        tipoId: yup
            .number()
            .typeError("El tipo de salida es requerido")
            .required("El tipo de salida es requerido")
            .min(1, "El tipo de salida es requerido")
    });

export default salidaEmpleadoValidacionEsquema;